import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FooterComponent } from '@rd/core/components/footer/footer.component';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import {
  BRAND_NAME,
  TENANT_PRIVACY_POLICY_URL,
  TENANT_PRIVACY_STATEMENT_URL,
  TENANT_TNCS_URL,
} from '@rd/core/tokens/rd-lib.token';
import { Nullable, StartsWithHttps } from 'global-types';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { StarNavLinksService } from '../../services/star-nav-links/star-nav-links.service';

@Component({
  selector: 'star-core-main-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StarFooterComponent extends FooterComponent {
  @HostBinding('class.star-core-main-footer') componentClass = true;

  copyrightPresentYear: number = new Date().getFullYear();

  constructor(
    private router: Router,
    protected urlUtilsService: UrlUtilsService,
    public starNavLinksService: StarNavLinksService,
    @Inject(BRAND_NAME) public brandName: string,
    @Inject(TENANT_TNCS_URL)
    public tenantTncsUrl: Nullable<StartsWithHttps>,
    @Inject(TENANT_PRIVACY_POLICY_URL)
    public tenantPrivacyPolicyUrl: Nullable<StartsWithHttps>,
    @Inject(TENANT_PRIVACY_STATEMENT_URL)
    public tenantPrivacyStatementUrl: Nullable<StartsWithHttps>,
  ) {
    super(brandName, urlUtilsService);
  }

  shouldHideFooter$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    // @ts-ignore Type 'Event_2 | Router' is not assignable to type 'Router'
    startWith(this.router),
    map((event: Router) => {
      const HIDDEN_FOOTER_URLS = ['/points_activity', '/transfer/programs'];
      const isOnHiddenRoute = !!HIDDEN_FOOTER_URLS.find((url) =>
        this.router.url.startsWith(url),
      );

      return isOnHiddenRoute;
    }),
  );
}
